import { Button, Col, Divider, Flex, Row, Space, Spin, Tag, Typography } from "antd";
import { observer } from "mobx-react";
import TaskItemStore from '../../stores/task/task-item';
import CloneCard from '../task/clone-card';
import { useStore } from "../../stores/root-store";
import Subjects from "../../models/subjects";

const { Text } = Typography;

const NewTicketTaskClonesItem: React.FC<{ task: TaskItemStore, subject: Subjects }> = ({ task, subject }) => {

    const { subjectStores } = useStore();
    const newTicket = subjectStores[subject].newTicket;
    const ticketBar = subjectStores[subject].ticketBar;

    const handleToggleClone = () => {
        task.toggleClones();
    }

    const handleChooseSameTask = () => {
        newTicket.toggleTaskInTicket(task.data.id, ticketBar);
    }

    const spinBlock = <Flex align='center' vertical>
        <Spin />
    </Flex>;

    return (
        <Row>
            <Col span={24}>
                <Flex align='center'>
                    <Space>
                        <div>[{task.data.source.name}][{task.data.theme.name}]{task.data.withSolution ? "[Есть решение]" : ""}</div>
                        {task.checkedClone && <Tag color="green">Клон выбран</Tag>}
                    </Space>
                    <Button type="link" onClick={handleToggleClone}>{task.clonesExpanded ? 'Скрыть клоны' : 'Показать клоны'}</Button>
                </Flex>
            </Col>
            <Col span={24}>
            </Col>
            {task.clonesExpanded &&
                <Col span={24}>
                    <Divider orientation="left">Похожие</Divider>
                    {task.loading ? spinBlock :
                        <Flex wrap="wrap" gap="middle" align="start">
                            {task.clones?.length === 0 &&
                                <Button type="link" onClick={handleChooseSameTask}>
                                    {task.checkedClone ? 'Нет клонов, в вариант добавлена данная задача. Убрать?' : 'Нет клонов. Оставить в варианте данную задачу?'}
                                </Button>
                            }
                            {task.clones.map(t => <CloneCard key={t.data.id} task={t} subject={task.subject} parent={task} />)}
                        </Flex>
                    }
                    <Divider />
                </Col>
            }
        </Row>
    );
}

export default observer(NewTicketTaskClonesItem);